import { useEffect } from 'react';

const allowedOrigins = [
  // "http://localhost:3000",
  // "http://localhost",
  "https://portal.qa.questboxes.com",
  "https://portal.uat.questboxes.com",
  "https://portal.questboxes.com",
  "https://hub.qa.prosolve.com",
  "https://hub.uat.prosolve.com",
  "https://hub.prosolve.com"
];

// Listens for the parent portal's auth handshake postMessage and calls back
// with the userId carried in the token
export default (onAuthorizedUserId) => {
  useEffect(() => {
    const handler = (event) => {
      if (!allowedOrigins.includes(event.origin)) {
        console.log(`Blocked message from disallowed origin: ${event.origin}`);
        return;
      }
      const token = event.data.token || '';
      const tokenParts = token.split('-');

      if (tokenParts[0] === 'isQuestAssessmentDashboardAuthorized' && tokenParts[1]) {
        onAuthorizedUserId(tokenParts[1]);
      }
    }

    window.addEventListener('message', handler);

    return () => {
      window.removeEventListener('message', handler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
